module.exports = "https://img1.huilianyi.com/1/create-expense@3x.1d511b64ee.appcore.png";